export default "__VITE_ASSET__CXZGvL2b__"